import {
  type ForkTemplateSchema,
  forkTemplateSchema,
} from "@gearbox-protocol/deploy-tools-shared";
import { api } from "api";
import ForkForm from "components/fork-form";
import { type FC, useMemo } from "react";
import type { FileWithPath } from "react-dropzone";
import { useLoaderData, useNavigate } from "react-router-dom";
import type { LoaderData } from "./loader";

const NewForkRoute: FC = () => {
  const { defaultValues, defaultFiles } = useLoaderData() as LoaderData;
  const navigate = useNavigate();

  const onSubmit = useMemo(
    () => async (data: ForkTemplateSchema, files: FileWithPath[]) => {
      // call parse to cleanup
      const input = forkTemplateSchema.parse(data);
      const resp = await api.createFork(input, files);
      await navigate(`/forks/${resp.executionId}`);
    },
    [navigate],
  );

  return (
    <ForkForm
      title="New Fork"
      submitButtonText="Create Fork"
      defaultValues={defaultValues}
      defaultFiles={defaultFiles}
      onSubmit={onSubmit}
    />
  );
};

export default NewForkRoute;
